import React, { useState, useEffect } from "react";
import "./HomePage.css";
import MedicinePill from "../../Assets/Images/medicinepill.png";
import Diagnostics from "../../Assets/Images/diagnostics.png";
import Clock from "../../Assets/Images/clock (2).png";
import Clock1 from "../../Assets/Images/clock (2) (1).png";
import Doctor from "../../Assets/Images/Doctor.png";
import FemDoctor from "../../Assets/Images/FemDoctor.png";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import DiagnosticPopup from "../DiagnosticPopup/DiagnosticPopup";
import BloodPressure from "../../Assets/Images/BloodPressureIcon.png";
import SetDate from "../SetDate/SetDate";
import DiagnosticSkip from "../DiagnosticSkip/DiagnosticSkip";
import CheckIcon from "../../Assets/Images/SVG/TickCheck.svg";
import OutlineTick from "../../Assets/Images/SVG/BeforeTick.svg";
// Swiper imports
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";

const HomePage = () => {
  const [checkedItems, setCheckedItems] = useState({});
  const [todayPlan, setTodayPlan] = useState({
    todayMedicine: [],
    todayTest: []
  });
  const [missedRoutine, setMissedRoutine] = useState({
    missedMedicine: [],
    missedTest: []
  });
  const [diagnostics, setDiagnostics] = useState([]);
  const [appointments, setAppointments] = useState([]);

  const [isSeeAll, setIsSeeAll] = useState(false);  // Today's plan SeeAll functionality
  const [isMissedSeeAll, setIsMissedSeeAll] = useState(false);  // Missed Routine SeeAll functionality
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isSkipVisible, setIsSkipVisible] = useState(false);
  const [greeting, setGreeting] = useState("");
  const [isSetDateVisible, setIsSetDateVisible] = useState(false);
  const [animationDirection, setAnimationDirection] = useState(""); // "slide-up" or "slide-down"



  // Greeting logic
  useEffect(() => {
    const currentHour = new Date().getHours();
    if (currentHour < 12) {
      setGreeting("Good Morning");
    } else if (currentHour < 18) {
      setGreeting("Good Afternoon");
    } else {
      setGreeting("Good Evening");
    }
  }, []);

  const handleRequestAppointment = (direction) => {
    setAnimationDirection(direction);
    setIsSetDateVisible(true);
  };

  const closeSetDate = () => {
    setAnimationDirection("slide-down");
    setTimeout(() => setIsSetDateVisible(false), 300); // Match animation duration
  };

  // Fetching today's plan and missed routine from API
  useEffect(() => {
    const authToken = sessionStorage.getItem("authToken");
    const patientId = sessionStorage.getItem("patientid");

    if (authToken && patientId) {
      fetch(`https://api.digidoc.co.in/patient/homepage/${patientId}`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 1 && data.data) {
            const todayMedicine = data.data.todayMedicine;
            const todayTest = data.data.todayTest;
            const missedMedicine = data.data.MissedtodayMedicine;
            const missedTest = data.data.Missedtodaytest;
            setTodayPlan({ todayMedicine, todayTest });
            setMissedRoutine({ missedMedicine, missedTest });
            // Diagnostics
            setDiagnostics(data.data.currentDateTest);

            // Appointments
            setAppointments(data.data.appointments.data);
          } else {
            console.error("Error fetching data");
          }
        })
        .catch((error) => {
          console.error("API request failed", error);
        });
    }
  }, []);

  const toggleCheckIcon = (medicineIndex) => {
    setCheckedItems((prevState) => ({
      ...prevState,
      [medicineIndex]: !prevState[medicineIndex], // Toggle the state
    }));
  };

  const doctorAppointments = [
    {
      name: "Dr. Luke Leon",
      followUpDate: "31-08-2024",
      lastAppointmentDate: "05-07-2024",
      image: Doctor,
    },
    {
      name: "Dr. Sarah Reed",
      followUpDate: "15-09-2024",
      lastAppointmentDate: "10-08-2024",
      image: FemDoctor,
    },
  ];
  return (
    <div className="dashboard-container">
      <Header />

      {/* Greeting */}
      <section className="greeting">
        <h3>{greeting}, 👋</h3>
      </section>

      {/* Today's Plan */}
      <section className="today-plan">
        <div className="section-header">
          <h3>Today's Plan</h3>
          <a
            href="#see-all"
            className="see-all"
            onClick={(e) => {
              e.preventDefault();
              setIsSeeAll((prev) => !prev);  // Toggle the seeAll state for today's plan
            }}
          >
            {isSeeAll ? "See Less" : "See All"}
          </a>
        </div>
        <div className="plan-card-container plan-card">
          {todayPlan.todayMedicine.concat(todayPlan.todayTest)
            .filter((_, index) => isSeeAll || index < 1) // Show all or limit to first item
            .map((plan, planIndex) => (
              <div key={planIndex} className="time-slot">
                <div className="time">
                  <img src={Clock} alt="Clock Icon" className="time-icons" />
                  {Object.keys(plan)[0]} {/* Time like 12:00 PM */}
                </div>
                <div className="medicines">
                  {plan[Object.keys(plan)[0]].map((item, itemIndex) => (
                    <div
                      key={itemIndex}
                      className="medicine"
                      onClick={() => toggleCheckIcon(`${planIndex}-${itemIndex}`)}
                    >
                      <img src={MedicinePill} alt={item.medicine_name || item.test_name} />
                      <div>
                        <h3>{item.medicine_name || item.test_name}</h3>
                        {/* <p>{item.dosage || item.instruction}</p> */}
                      </div>
                      <div className="icon-end">
                        <img
                          src={checkedItems[`${planIndex}-${itemIndex}`] ? CheckIcon : OutlineTick}
                          alt="Toggle Icon"
                          className="toggle-icon"
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
        </div>
      </section>

      {/* Missed Routine */}
      <section className="missed-routine">

        <div className="section-header">
          <h3>Missed Routine</h3>
          <a
            href="#see-all"
            className="see-all"
            onClick={(e) => {
              e.preventDefault();
              setIsMissedSeeAll((prev) => !prev);  // Toggle the seeAll state for missed routine
            }}
          >
            {isMissedSeeAll ? "See Less" : "See All"}
          </a>
        </div>
        <div className="plan-card-container plan-card">
          {missedRoutine.missedMedicine.concat(missedRoutine.missedTest)
            .filter((_, index) => isMissedSeeAll || index < 1) // Show all or limit to first item
            .map((routine, routineIndex) => (
              <div key={routineIndex} className="time-slot">
                <div className="time">
                  <img src={Clock1} alt="Clock Icon" className="time-icons" />
                  {Object.keys(routine)[0]} {/* Time like 12:30 PM */}
                </div>
                <div className="medicines">
                  {routine[Object.keys(routine)[0]].map((item, itemIndex) => (
                    <div
                      key={itemIndex}
                      className="medicine"
                      onClick={() => toggleCheckIcon(`missed-${routineIndex}-${itemIndex}`)}
                    >
                      {/* Check if item is medicine or test */}
                      <img
                        src={item.category === "medicine" ? MedicinePill : BloodPressure}
                        alt={item.medicine_name || item.test_name}
                      />
                      <div>
                        <h3>{item.medicine_name || item.test_name}</h3>
                        {/* <p>{item.dosage || item.instruction}</p> */}
                      </div>
                      <div className="icon-end">
                        <img
                          src={checkedItems[`missed-${routineIndex}-${itemIndex}`] ? CheckIcon : OutlineTick}
                          alt="Toggle Icon"
                          className="toggle-icon"
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
        </div>
      </section>

      {/* Diagnostics */}
      <section className="diagnostic-section">
        <h3 className="section-title">Diagnostics</h3>
        {diagnostics.length > 0 ? (
          diagnostics.map((diagnostic, index) => (
            <div className="diagnostic-card" key={index}>
              <div className="diagnostic-left">
                <img
                  src={Diagnostics}
                  alt="Diagnostic Icon"
                  className="diagnostic-icon"
                />
              </div>
              <div className="diagnostic-right">
                <div className="diagnostic-header">
                  <span className="diagnostic-title">{diagnostic.test_name}</span>
                  <span className="diagnostic-date">{diagnostic.start_date}</span>
                </div>
                <h3>Have you taken the test?</h3>
                <div className="response">
                  <button className="no" onClick={() => setIsSkipVisible(true)}>
                    NO
                  </button>
                  <button className="yes" onClick={() => setIsPopupVisible(true)}>
                    YES
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="plan-card">
            <h5>No diagnostics scheduled for today.</h5>
          </div>
        )}
      </section>


      {/* Appointments */}

      <section className="appointment-section">
        <h3 className="section-title">Appointments</h3>
        {appointments.length > 0 ? (
          <Swiper
            spaceBetween={20}
            slidesPerView={1}
            pagination={{ clickable: true }}
            modules={[Pagination]}
          >
            {appointments.map((appointment, index) => (
              <SwiperSlide key={index}>
                <div className="doctor-card">
                  <div className="doctor-card-left">
                    <img src={appointment.doctor_profile_image} alt={appointment.name} />
                  </div>
                  <div className="doctor-card-right">
                    <h3>{appointment.name}</h3>
                    <p>Next Follow-up</p>
                    <span className="follow-up-date">
                      {appointment.next_appointment_date}
                    </span>
                    <p>Last Appointment</p>
                    <span className="last-appointment-date">
                      {appointment.last_consultation_date}
                    </span>
                    <button
                      className="appointment-button"
                      onClick={() => handleRequestAppointment("slide-up")}
                    >
                      Request Appointment
                    </button>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <p>No upcoming appointments.</p>
        )}
      </section>


      <Footer />

      {/* Render Popups */}
      {isPopupVisible && (
        <DiagnosticPopup onClose={() => setIsPopupVisible(false)} />
      )}
      {isSkipVisible && (
        <DiagnosticSkip onClose={() => setIsSkipVisible(false)} />
      )}

      {/* Render SetDate */}
      {isSetDateVisible && (
        <div className={`set-date-wrapper ${animationDirection}`}>
          <SetDate onClose={closeSetDate} />
        </div>
      )}
    </div>
  );
};

export default HomePage;
